import React, { useState } from 'react'
import { minimumPriceValidator } from 'modules/utils/validators'
import { Form, Input, InputNumber, Switch } from 'antd'

import './index.styl'
import SingleDatePicker from '../../../../Header/DetailsFields/SingleDatePicker'

const { Item } = Form

const VirtualMeetingItems = ({ namePrefix, categoryData, form }) => {
  const [isEarlyBird, setIsEarlyBird] = useState(categoryData?.hasEarlyBird || false)
  const [earlyBirdDate, setEarlyBirdDate] = useState(categoryData?.earlyBirdDate || '')
  const [availableTicket, setAvailableTicket] = useState(form.getFieldValue('showAvailableTickets') || false)

  const availableTicketHandler = () => {
    setAvailableTicket(!availableTicket)
    // form.setFieldsValue({
    //  showAvailableTickets: !availableTicket,
    // })
  }
  const onCheckEarlyBird = () => setIsEarlyBird(!isEarlyBird)

  return (
    <>
      <div className='topField'>
        <div className='inputFields'>
          <Item
            rules={[{ required: true, message: 'Enter Ticket Category Name' }]}
            name={[namePrefix, 'name']}
            label='Ticket Category Name'
            initialValue={namePrefix === 0 ? 'Virtual Meeting' : ''}

          >
            <Input placeholder='Virtual Meeting' className='inputName' />
          </Item>
          <div className='priceQuantityWrapper'>
            <div className='mobileFlex'>
              <Item
                name={[namePrefix, 'price']}
                label='Ticket Price'
                rules={[
                  { required: true, message: 'Enter price' },
                  minimumPriceValidator,
                ]}
              >
                <InputNumber placeholder='0' className='price' min={0} />
              </Item>
              <Item
                rules={[
                  { required: true, message: 'Enter quantity' },
                  { type: 'number', max: 100000, message: 'Quantity cannot exceed 100 000' },
                  {
                    validator: (_, value) =>
                      Number.isInteger(value) ? Promise.resolve() : new Promise((resolve, reject) => {
                        reject(new Error('Quantity must be an integer!'))
                      }),
                  },
                ]}
                name={[namePrefix, 'quantity']}
                label='Tickets Quantity'
              >
                <InputNumber
                  className='quantity'
                  placeholder='0'
                  min={0}
                />
              </Item>
            </div>
          </div>
        </div>
      </div>
      <div className='zoomItemsWrapper'>
        <Item
          rules={[{ required: true, message: 'Enter Zoom URL' }]}
          label='Zoom URL'
          name={[namePrefix, 'zoomUrl']}
          normalize={v => v.trimStart()}
        >
          <Input placeholder='Enter your personal link' className='zoomUrl' />
        </Item>
        <div className='lastFieldZoomWrapper'>
          <Item
            label='Zoom Meeting passcode'
            rules={[{ required: true, message: 'Enter Zoom Meeting passcode' }]}
            name={[namePrefix, 'zoomPassword']}
            className='item'
            normalize={v => v.trimStart()}
          >
            <Input placeholder='Enter your passcode' className='meetingPasscode' />
          </Item>
          <Item
            rules={[{ required: true, message: 'Enter maximum event participants' }]}
            label='Maximum event participants'
            name={[namePrefix, 'zoomEventParticipants']}
            className='item participants'
          >
            <InputNumber className='participantsInput' placeholder='0' type='number' min={1} />
          </Item>
        </div>
      </div>
      <div className='radioItemField'>
        <Item
          name={[namePrefix, 'showAvailableTickets']}
          valuePropName='checked'
          initialValue={availableTicket}
          className='item'
        >
          <Switch onChange={availableTicketHandler} defaultChecked={availableTicket} />
        </Item>
        <div className='text'>Show available tickets</div>
      </div>
      <div className='radioItemField earlyBirdDateItem'>
        <Item
          name={[namePrefix, 'hasEarlyBird']}
          className='item'
          valuePropName='checked'
        >
          <Switch onChange={onCheckEarlyBird} defaultChecked={isEarlyBird} />
        </Item>
        <div className='text'>Early Bird Special</div>
      </div>
      {isEarlyBird && (
        <div className='earlyBirdFieldsWrapper'>
          <SingleDatePicker label='Early Bird' namePrefix={namePrefix} nameText='earlyBirdDate' fromDate={earlyBirdDate} form={form} setFromDate={setEarlyBirdDate} title='Early Bird Date' />
          <Item
            name={[namePrefix, 'earlyBirdPrice']}
            dependencies={[[namePrefix, 'price']]}
            label='Price'
            rules={[
              { required: true, message: 'Enter price' },
              minimumPriceValidator,
            ]}
            className='earlyBirdPrice'
          >
            <InputNumber placeholder='0' min={0} />
          </Item>
        </div>
      )}
    </>
  )
}

export default VirtualMeetingItems
